import React, { FC } from 'react';
import { withRouter } from 'react-router';

export const REFRIGERANT_SUBNAV_KEYS = { ASSETS: 'assets', EVENT_LOG: 'events' };

interface RefrigerantSubnavProps {
	activeKey: string;
	userType: string;
	history?: any;
}

/**
 * The Assets / Event Log switch inside the Refrigerant Tracking tab.
 *
 * A second level of navigation below the Assets page's own tab strip, so it is deliberately NOT
 * `SubnavTabs` — that component styles itself for the coloured navblock it sits in, and this one sits
 * on the white page body. Two routes, one appliance-centric and one event-centric, over the same
 * ledger.
 *
 * Rendered as the `leftActions` of the page's table header, sharing a line with the search box, so it
 * carries NO horizontal padding of its own — the header row already insets its left group, and a
 * second inset here would push the tabs out of line with the search box below them.
 */
const RefrigerantSubnav: FC<RefrigerantSubnavProps> = ({ activeKey, userType, history }) => {
	const tabs = [
		{
			key: REFRIGERANT_SUBNAV_KEYS.ASSETS,
			name: 'Assets',
			path: `/${userType}/assets/overview/refrigerant`,
		},
		{
			key: REFRIGERANT_SUBNAV_KEYS.EVENT_LOG,
			name: 'Event Log',
			path: `/${userType}/assets/overview/refrigerant/events`,
		},
	];

	return (
		<div className="mr-2 flex flex-row items-center gap-4">
			{tabs.map((tab) => {
				const isActive = tab.key === activeKey;
				return (
					<div
						key={tab.key}
						onClick={() => (isActive ? undefined : history.push(tab.path))}
						// `py-2` keeps the tabs to the search box's own height so they share a baseline with the
						// controls beside them; the underline then lands on the row's bottom edge. `border-solid`
						// is required, not decorative — preflight is off in this repo, so a width utility alone
						// leaves border-style at `none` and no underline renders. Transparent when inactive so
						// the tab does not shift by 2px on selection.
						className={`bodymedium cursor-pointer border-0 border-b-2 border-solid py-2 ${
							isActive
								? 'border-current text-character-primary'
								: 'border-transparent text-character-secondary'
						}`}
					>
						{tab.name}
					</div>
				);
			})}
		</div>
	);
};

export default withRouter<any, any>(RefrigerantSubnav);
